__turbopack_context__.v({
  "button": "EmailWaitlist-module__BoSndW__button",
  "input": "EmailWaitlist-module__BoSndW__input",
  "root": "EmailWaitlist-module__BoSndW__root",
});
